export const CURRENCY_SYMBOL = '₱'
export const CURRENCY_CODE = 'PHP'
export const LOCALE = 'en-PH'

export function formatPrice(amount: number): string {
  return `${CURRENCY_SYMBOL}${amount.toLocaleString(LOCALE, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

export function formatPriceShort(amount: number): string {
  if (amount >= 1000) {
    return `${CURRENCY_SYMBOL}${(amount / 1000).toFixed(1)}k`
  }
  return formatPrice(amount)
}
